export enum DASHBOARDS {
  LAST_MONTH = "last_month",
  CURRENT_MONTH = "current_month",
  ALL_TIME = "all_time",
}
